<template>
  <rpm-modal :open="modalOpen" persist header="Alterar organização">
    <rpm-input type="select" :options="organizations"
               optionLabel="name"
               optionValue="id"
               label="Organização"
               required
               v-model="form.current_organization_id"/>
    <section class="flex flex-row justify-center gap-6 mt-4">
      <rpm-button @click="changeOrganization" label="Salvar"/>
      <rpm-button @click="closeModal" label="Fechar" color="gray"/>
    </section>
  </rpm-modal>
</template>

<script>
import {onMounted, ref} from 'vue'
import organizationsRepository from '#repositories/organizationsRepository'
import procedureRepository from '#repositories/procedureRepository'
import RpmModal from "#components/RpmModal.vue";

export default {
  name: "ChangeOrganization",
  components: {
    RpmModal
  },
  props: {
    modalOpen: {
      type: Boolean,
      default: false
    },
    procedure: {
      type: Object,
      required: true
    }
  },
  methods: {
    changeOrganization() {
      procedureRepository.changeOrganization(this.procedure.id, this.form).then((response) => {
        this.$emit('organizationChanged')
        this.$notify(response.message, response.severity)
      })
    }
  },
  setup(props, {emit}) {
    const form = ref({
      current_organization_id: null
    })

    const organizations = ref([])

    function fetchOrganizations() {
      organizationsRepository.getOrganizations().then((response) => {
        organizations.value = response.data
      })
    }

    function closeModal() {
      form.value.current_organization_id = null
      emit('close')
    }

    onMounted(() => {
      fetchOrganizations()
    })

    return {
      form,
      organizations,
      closeModal
    }
  }
}
</script>

<style lang="scss" scoped>

</style>